export default "__VITE_ASSET__CkI35NWJ__"